import React, { useEffect, useState } from 'react';
import { Container, DateRangeWrapper, Wrapper, Row, DateInput, DateTitle, SaveButton } from './styled';
import DatePicker from 'react-datepicker';
import { pt } from 'date-fns/locale';
import Button from '../../ReUsableComponents/Button';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import { dateEntregaDatesUpdate } from '../../../../../Services/cardService';

const DataEntregaPopover = (props) => {
	const dispatch = useDispatch();
	const card = useSelector((state) => state.card);

	// Inicializa o estado da data de entrega
	const [dateEntrega, setDateEntrega] = useState(
		card.dateEntrega ? moment(card.dateEntrega).toDate() : null
	);

	useEffect(() => {
		// Atualiza o estado quando o card.dateEntrega mudar
		if (card.dateEntrega) {
			setDateEntrega(moment(card.dateEntrega).toDate());
		}
	}, [card.dateEntrega]);

	// Salva a data de entrega
	const handleSaveClick = async () => {
		props.closeCallback();
		await dateEntregaDatesUpdate(
			card.cardId,
			card.listId,
			card.boardId,
			dateEntrega ? moment(dateEntrega).format('YYYY-MM-DD') : null,
			dispatch
		);
	};

	// Remove a data de entrega
	const handleRemoveClick = async () => {
		props.closeCallback();
		await dateEntregaDatesUpdate(card.cardId, card.listId, card.boardId, null, dispatch);
	};

	return (
		<Container>
			<DateRangeWrapper>
				<DatePicker
					selected={dateEntrega}
					onChange={(date) => setDateEntrega(date)}
					dateFormat="dd/MM/yyyy"
					locale={pt}
					placeholderText="Selecione uma data"
					inline
				/>
			</DateRangeWrapper>
			<Wrapper>
				<DateTitle>Data de Entrega</DateTitle>
				<Row>
					<DateInput
						value={dateEntrega ? moment(dateEntrega).format('DD/MM/YYYY') : ''}						
					/>
				</Row>
				<SaveButton onClick={handleSaveClick}>Salvar</SaveButton>
				<Button clickCallback={handleRemoveClick} title="Remover" />
			</Wrapper>
		</Container>
	);
};

export default DataEntregaPopover;
